import { IVendorData } from '../../../types';

export const APP_CENTER_TEXTS = {
  PAGE_TITLE: 'APP_CENTER_PAGE_TITLE',
  NO_RESULTS: 'APP_CENTER_NO_RESULTS',
  NO_RESULTS_SEARCH: 'APP_CENTER_SEARCH_NO_RESULTS',
  BANK_DETAILS: 'APP_CENTER_BANK_DETAILS',
  ROUTING_NUMBER: 'APP_CENTER_ROUTING_NUMBER',
  ACCOUNT_NUMBER: 'APP_CENTER_ACCOUNT_NUMBER',
} as const;

export const LILI_INVOICES_ID = 1;

export const EMPTY_VENDOR_DATA: IVendorData = {
  displayOptions: [{
    actions: [{
      text: '',
      type: '',
      url: '',
    },
    {
      text: '',
      type: '',
      url: '',
    }],
    disclaimer: '',
    steps: [],
    title: '',
    subtitle: '',
    type: '',
    vendorDescription: '',
    verificationDisplayType: '',
  }],
  id: 0,
  isInstantIntegrationAvailable: false,
  logoUrl: '',
  name: '',
};
